// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.conflictType .card {
    padding: 0 !important;
    height: 100%;
    width: 100%;
}
.conflictType .card-body {
    padding: 8px 12px !important;
}
.conflictType .terms,
.conflictType .terms label {
    height: 100% !important;
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";AACA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;AACf;AACA;IACI,4BAA4B;AAChC;AACA;;IAEI,uBAAuB;IACvB,WAAW;AACf","sourcesContent":["\n.conflictType .card {\n    padding: 0 !important;\n    height: 100%;\n    width: 100%;\n}\n.conflictType .card-body {\n    padding: 8px 12px !important;\n}\n.conflictType .terms,\n.conflictType .terms label {\n    height: 100% !important;\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
